const tag = '[Stepper]';

export class NextStep {
  static readonly type = `${tag} NextStep`;
}

export class PreviousStep {
  static readonly type = `${tag} PreviousStep`;
}

export class SkipToStep {
  static readonly type = `${tag} skip to step`;
  constructor(public targetStep: number) {}
}

export class UpdateTooltipMessage {
  static readonly type = `${tag} update tooltip message`;
  constructor(public tooltipMessage: string) {}
}

export class UpdateMonetizationStep {
  static readonly type = `${tag} update monetization step`;
  constructor(public shouldInclude: boolean) {}
}

export class UpdatePlanStep {
  static readonly type = `${tag} update plan step`;
  constructor(public isPaidApp: boolean) {}
}
